import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import MUISelect, { SelectProps as MUISelectProps } from "@material-ui/core/Select";
import React, { FC } from "react";
import { styled } from "@material-ui/styles";

export type SelectOptionType = {
  label: string;
  value: string;
};

type SelectProps = {
  options: SelectOptionType[];
};

const StyledFormControl = styled(FormControl)<FormControlProps>(() => ({
  "& .MuiInputBase-root": {
    height: 48,
  },
  "& label": {
    transform: "translate(14px, 17px) scale(1)",
  },
  "& label.Mui-focused": {
    color: "#034980",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #9E9E9E",
      borderRadius: 4,
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #034980",
    },
  },
}));

const SelectWithCheckboxes: FC<MUISelectProps & FormControlProps & SelectProps> = ({
  variant,
  className,
  label,
  value,
  onChange,
  name,
  options,
  ...rest
}) => {
  const valueAsType = value as Array<string>;

  return (
    <StyledFormControl variant={variant ?? "outlined"} className={className} fullWidth>
      <InputLabel>{label}</InputLabel>
      <MUISelect
        value={value}
        onChange={onChange}
        renderValue={(selected) =>
          options
            .filter((x) => (selected as string[]).includes(x.value))
            .map((x) => x.label)
            ?.join(", ")
        }
        name={name}
        label={label}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        multiple
        {...rest}
      >
        {!value ? <MenuItem>{label}</MenuItem> : null}
        {options.map((option: SelectOptionType) => (
          <MenuItem key={option.label} value={option.value}>
            <Checkbox checked={valueAsType.includes(option.value)} color="primary" />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </MUISelect>
    </StyledFormControl>
  );
};

export default SelectWithCheckboxes;
